<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <resource-index header="Salesforce relaties" endpoint="accounts" show-route="accounts.view" />
      </div>
    </div>
  </div>
</template>
<script>
import ResourceIndex from '../../components/ResourceIndexGroup';

export default {
  name: 'accounts',
  components: { ResourceIndex }
}

</script>
